const templateContacts = {
  dom_map: null,

  init() {
    this.map.init();
  },

  map: {
    lat: false,
    lng: false,
    pin: false,
    zoom: 15,

    init: function () {
      templateContacts.map.render_map();
    },

    render_map: function () {
      var self = this;

      const dom_map = $("#map-wrap");
      if (!dom_map.length) {
        return;
      }

      if (dom_map.data("zoom")) {
        self.zoom = parseInt(dom_map.data("zoom"));
      }

      if (dom_map.data("pin")) {
        self.pin = dom_map.data("pin");
      }

      var map = new google.maps.Map(dom_map[0], {
        center: {
          lat: dom_map.data("lat"),
          lng: dom_map.data("lng"),
        },
        zoom: self.zoom,
        disableDefaultUI: false,
        scrollwheel: false,
        draggable: true,
        // styles: [ { "featureType": "water", "elementType": "geometry", "stylers": [ { "color": "#e9e9e9" }, { "lightness": 17 } ] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [ { "color": "#f5f5f5" }, { "lightness": 20 } ] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [ { "color": "#ffffff" }, { "lightness": 17 } ] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [ { "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 } ] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [ { "color": "#ffffff" }, { "lightness": 18 } ] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [ { "color": "#ffffff" }, { "lightness": 16 } ] }, { "featureType": "poi", "elementType": "geometry", "stylers": [ { "color": "#f5f5f5" }, { "lightness": 21 } ] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [ { "color": "#dedede" }, { "lightness": 21 } ] }, { "elementType": "labels.text.stroke", "stylers": [ { "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 } ] }, { "elementType": "labels.text.fill", "stylers": [ { "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 } ] }, { "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType": "transit", "elementType": "geometry", "stylers": [ { "color": "#f2f2f2" }, { "lightness": 19 } ] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [ { "color": "#fefefe" }, { "lightness": 20 } ] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [ { "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 } ] }]
      });

      map.markers = [];

      var center = new google.maps.LatLng(
        dom_map.data("lat"),
        dom_map.data("lng")
      );
      var marker_options = {
        position: center,
        map: map,
        animation: google.maps.Animation.DROP,
      };
      if (self.pin) {
        marker_options.icon = self.pin;
      }
      var marker = new google.maps.Marker(marker_options);
      map.markers.push(marker);
    },
  },
};

export default templateContacts;
